import { Routes } from '@angular/router';

import { editUserUnsavedGuard } from './pages/private/amministrazione/edit-user-page/edit-user-unsaved.guard';
import { LandingPage } from './pages/private/landing-page/landing-page';
import { RootRedirect } from './pages/public/sso/sso-root-redirect/sso-root-redirect';
import { SsoFast } from './pages/public/sso/sso-fast/sso-fast';

export const routes: Routes = [
  {
    path: '',
    component: RootRedirect
  },
  {
    path: 'sso-fast',
    component: SsoFast
  },
  {
    path: 'login',
    loadComponent: () => import('./pages/public/login/login').then(m => m.Login)
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('./pages/public/forgot-password/forgot-password').then(m => m.ForgotPassword)
  },
  {
    path: 'signup',
    loadComponent: () => import('./pages/public/signup/pages/signup.pages').then(m => m.Signup)
  },
  {
    path: 'recovery',
    loadComponent: () => import('./pages/public/reset-password/reset-password').then(m => m.ResetPassword)
  },
  {
    path: 'landing-page',
    component: LandingPage
  },
  {
    path: 'settings',
    loadComponent: () => import('./pages/private/settings/settings').then(m => m.Settings)
  },
  {
    path: 'active-sessions',
    loadComponent: () => import('./pages/private/active-sessions/active-sessions').then(m => m.ActiveSessions)
  },
  {
    path: 'amministrazione',
    loadComponent: () => import('./pages/private/amministrazione/pages/amministrazione.pages').then(m => m.Amministrazione)
  },
  {
    path: 'amministrazione/ruoli-mail',
    loadComponent: () => import('./pages/private/amministrazione/mailboxes-ruoli/mailboxes-ruoli').then(m => m.MailboxesRuoli)
  },
  {
    path: 'amministrazione/utenti/:userId',
    loadComponent: () => import('./pages/private/amministrazione/edit-user-page/edit-user-page').then(m => m.EditUserPage),
    canDeactivate: [editUserUnsavedGuard]
  }
];
